module.exports = __webpack_public_path__ + "img/9.c5522c45.webp";